import { action } from 'mobx';
import { ShipmentInfoReturnService } from 'common/data';
import { BaseStore } from 'core/stores';

class ShipmentInfoReturnStore extends BaseStore {
	constructor(rootStore) {
		super(new ShipmentInfoReturnService(rootStore.app.baasic.apiClient));
	}

	@action
	findShipmentInfoReturn = async filter => {
		const response = await this.service.find(filter);
		response.data.searchQuery = filter.search;
		this.response = response.data;
		return response.data;
	};

	@action
	reprintLabel = async (shipmentInfoReturnId, getLabel = true) => {
		const response = await this.service.reprintLabel(shipmentInfoReturnId, getLabel);
		this.item = response;
		return this.item;
	};

	@action
	createReturnLabel = async returnLabelParams => {
		const response = await this.service.createReturnLabel(returnLabelParams);
		this.item = response;
		return this.item.data;
	};
}

export default ShipmentInfoReturnStore;



// WEBPACK FOOTER //
// ./src/modules/shipment-info-return/stores/ShipmentInfoReturnStore.js